import { NavigationBarBreadCrumbs } from "@/components/molecules/BackNav";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useSidebar } from "@/components/ui/sidebar";
import { ENV } from "@/constants/env";
import { SIDEBAR_NAMES } from "@/constants/sidebar";
import { useGetUserSession } from "@/lib/useQuery/user/useGetUserSession";
import useSignOut from "@/lib/useQuery/user/useSignOut";
import { useUserData } from "@/lib/useQuery/user/useUserData";
import { useOrganizationStore, useUserStore } from '@/lib/zustand/useStore';
import { ChevronDown, HelpCircle, Menu } from "lucide-react";
import { useEffect } from "react";
import { Link, NavLink, useSearchParams } from "react-router-dom";
import { UserAvatar } from "../../../features/user/components/atoms/user-avatar";


export function NavigationBar() {
    const { toggleSidebar, setOpen } = useSidebar();
    const userStore = useUserStore(state => state);
    const { data: user } = useUserData();


    if (user?.first_name && user?.last_name) {
        userStore.first_name = user?.first_name;
        userStore.last_name = user?.last_name;
    }
    const { data: session, isLoading } = useGetUserSession();
    const setSession = useUserStore(state => state.setSession);

    useEffect(() => {
        setSession(session);
        if (!session) {
            setOpen([]);
        }
    }, [session, setSession]);

    /*
    * Logic for sidebar auto open
    */
    const [searchParams, setSearchParams] = useSearchParams();
    const showMenu = searchParams.get('showMenu') || false;
    useEffect(() => {
        if (showMenu) {
            setOpen([SIDEBAR_NAMES.APP_SIDEBAR]);
            searchParams.delete('showMenu');
            setSearchParams(searchParams);
        }
    }, [showMenu, searchParams, setSearchParams]);
    // ---

    const logoutHandler = useSignOut();
    const { organization } = useOrganizationStore();
    const orgRole = organization?.organisation_members?.find(member => member.id === userStore?.id)?.role;

    // if (isLoading) { return <LoaderWithBackdrop /> }
    return (
        <div className="h-navbar">
            <nav className="fixed z-50 flex h-navbar p-2 !bg-primary transition text-white top-0 left-0 right-0">
                <div className="absolute left-0 inset-y-0 w-[var(--sidebar-width)] bg-white/5"></div>
                <div className="relative flex items-center justify-between w-full gap-4 px-6">
                    <div className="flex items-center text-xl font-black">
                        {
                            userStore?.id && (
                                <Menu className="mr-6 cursor-pointer" onClick={() => {
                                    toggleSidebar([SIDEBAR_NAMES.APP_SIDEBAR]);
                                }} />
                            )
                        }
                        <Link to={"/"}>
                            <div className="flex text-lg sm:text-2xl">
                                Collaborate
                                {ENV.DEV &&
                                    <span className="text-xs fw-normal sm:text-sm ms-2">Dev build</span>
                                }
                            </div>
                        </Link>
                    </div>
                    <div className="flex items-center justify-center h-full absolute left-[var(--sidebar-width)]">
                        <NavigationBarBreadCrumbs />
                    </div>
                    <ul className='flex justify-end grow'>
                        <li className="hidden sm:list-item">
                            <div
                                className="space-x-1 navigationBar__link"
                                onClick={() => {
                                    toggleSidebar([SIDEBAR_NAMES.HELP_SIDEBAR]);
                                }}
                            >
                                <HelpCircle size={20} /> <span>Help</span>
                            </div>
                        </li>
                        <li className="hidden sm:list-item">
                            <NavLink className="navigationBar__link" to={"/about"} >
                                <div>About Us</div>
                            </NavLink>
                        </li>

                        {!userStore?.id && (
                            <li>
                                <NavLink className="navigationBar__link" to={"/login"}>
                                    <div>Login</div>
                                </NavLink>
                            </li>
                        )}
                    </ul>


                    {userStore?.id && (
                        <DropdownMenu>
                            <DropdownMenuTrigger className="" asChild>
                                <div className="flex items-center gap-2">
                                    <UserAvatar />
                                    <ChevronDown size={16} className="ml-auto text-white" />
                                </div>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent className="w-full max-w-full p-0 border" side="bottom">
                                <DropdownMenuLabel className="bg-primary">
                                    <div className="flex items-center w-full gap-2 bg-primary">
                                        <div className="flex cursor-pointer">
                                            <div className="flex items-center justify-center w-8 h-8 font-black bg-white rounded-[8px] !text-primary text-md">
                                                {(userStore.first_name?.[0] || "") + "" + (userStore.last_name?.[0] || "")}
                                            </div>
                                        </div>
                                        <div className="text-white">
                                            <div className="text-lg">
                                                {userStore.first_name} {userStore.last_name}
                                            </div>
                                            <div className="text-xs">
                                                {orgRole?.label ? orgRole.label : ''}
                                            </div>
                                        </div>
                                    </div>
                                </DropdownMenuLabel>
                                <DropdownMenuItem>
                                    <Link to="/settings">
                                        Account Settings
                                    </Link>
                                </DropdownMenuItem>
                                <DropdownMenuItem onClick={logoutHandler}>
                                    Logout
                                </DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    )}
                </div>
            </nav>
        </div>
    )
}

